/**
 * succMessage.js
 * template for displaying succesful messages from server calls
 */
import React from 'react';
import '../../style/SuccMessage.css';
import Button from 'react-bootstrap/Button';

function SuccMessage({message, clear}) {
    return (
        <div id="succ-message">
            <p id="succ-body">{message}</p>
            <Button variant="secondary" id="succ-btn" onClick={clear}>Clear</Button>
        </div>
    )
};

export default SuccMessage;